
export const SLOPE_CONFIG = {
  widthRatio: 0.6,  
};

export function getSlopeBounds(canvasWidth: number) {
  const center = canvasWidth / 2;
  const halfPath = (canvasWidth * SLOPE_CONFIG.widthRatio) / 2;

  return {
    left: center - halfPath,
    right: center + halfPath
  };
}
/**
 * Artwork measurements (pixels in the source PNGs; "visible" = alpha > 16).
 * The background (newBack.png) is drawn scaled to the canvas width, so its
 * painted edge trees are EDGE_TREE_WIDTH * canvasWidth / BACKGROUND.width wide.
 * Obstacles are sized from the same factor so an obstacle tree matches them.
 * Re-measure if any of these images are replaced.
 */
export const BACKGROUND_ART = { width: 849, edgeTreeWidth: 63 };
export const OBSTACLE_ART = {
  tree: { width: 249, height: 438, visibleWidth: 234 },  // Tree00.png / Tree01.png
  rock: { width: 500, height: 503, visibleWidth: 356 },  // Rock00.png
};
/** Rocks keep the size they always had next to trees (visible width ≈ 0.68 of a tree). */
const ROCK_TO_TREE = 0.68;
/** Seeded spawn scale (1.2–1.6, see SeededPath) maps to ±15% variety around the edge-tree size. */
const SPEC_SCALE_MID = 1.4;

export interface ObstacleSize {
  width: number;
  height: number;
  /** Multiplier for the ground shadow, proportional to the visible width. */
  shadowScale: number;
}

export function obstacleSize(canvasWidth: number, isTree: boolean, specScale: number): ObstacleSize {
  const variety = specScale / SPEC_SCALE_MID;
  const treeVisible = BACKGROUND_ART.edgeTreeWidth * (canvasWidth / BACKGROUND_ART.width) * variety;
  const art = isTree ? OBSTACLE_ART.tree : OBSTACLE_ART.rock;
  const visible = isTree ? treeVisible : treeVisible * ROCK_TO_TREE;
  const width = visible * art.width / art.visibleWidth;
  // Shadow radii were 20·scale (trees) and 18·scale (rocks) at the old ~66 / ~45 px visible widths.
  return { width, height: width * art.height / art.width, shadowScale: visible / (isTree ? 47 : 32) };
}
